/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPACCOUNTHOLDERTYPE } from './IAPACCOUNTHOLDERTYPE';
import {
    IAPACCOUNTHOLDERTYPEFromJSON,
    IAPACCOUNTHOLDERTYPEFromJSONTyped,
    IAPACCOUNTHOLDERTYPEToJSON,
} from './IAPACCOUNTHOLDERTYPE';
import type { IAPPARTYTYPE } from './IAPPARTYTYPE';
import {
    IAPPARTYTYPEFromJSON,
    IAPPARTYTYPEFromJSONTyped,
    IAPPARTYTYPEToJSON,
} from './IAPPARTYTYPE';

/**
 * 
 * @export
 * @interface PaymentDetailsPayerOptionViewModel
 */
export interface PaymentDetailsPayerOptionViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsPayerOptionViewModel
     */
    partyId: number;
    /**
     * 
     * @type {IAPPARTYTYPE}
     * @memberof PaymentDetailsPayerOptionViewModel
     */
    partyType: IAPPARTYTYPE;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsPayerOptionViewModel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsPayerOptionViewModel
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsPayerOptionViewModel
     */
    verificationNumber?: string;
    /**
     * 
     * @type {IAPACCOUNTHOLDERTYPE}
     * @memberof PaymentDetailsPayerOptionViewModel
     */
    accountHolderType: IAPACCOUNTHOLDERTYPE;
}

/**
 * Check if a given object implements the PaymentDetailsPayerOptionViewModel interface.
 */
export function instanceOfPaymentDetailsPayerOptionViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partyId" in value;
    isInstance = isInstance && "partyType" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "accountHolderType" in value;

    return isInstance;
}

export function PaymentDetailsPayerOptionViewModelFromJSON(json: any): PaymentDetailsPayerOptionViewModel {
    return PaymentDetailsPayerOptionViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsPayerOptionViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsPayerOptionViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': json['PartyId'],
        'partyType': IAPPARTYTYPEFromJSON(json['PartyType']),
        'name': json['Name'],
        'surname': !exists(json, 'Surname') ? undefined : json['Surname'],
        'verificationNumber': !exists(json, 'VerificationNumber') ? undefined : json['VerificationNumber'],
        'accountHolderType': IAPACCOUNTHOLDERTYPEFromJSON(json['AccountHolderType']),
    };
}

export function PaymentDetailsPayerOptionViewModelToJSON(value?: PaymentDetailsPayerOptionViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'PartyType': IAPPARTYTYPEToJSON(value.partyType),
        'Name': value.name,
        'Surname': value.surname,
        'VerificationNumber': value.verificationNumber,
        'AccountHolderType': IAPACCOUNTHOLDERTYPEToJSON(value.accountHolderType),
    };
}

